import React from 'react';

const Pagination2 = ({ currentPage, totalPages, onPageChange }) => {
  const pageNumbers = [];

  const displayRange = 4;
  const startPage = Math.max(1, currentPage - Math.floor(displayRange / 2));
  const endPage = Math.min(totalPages, startPage + displayRange - 1);

  for (let i = startPage; i <= endPage; i++) {
    console.log("Start Page :"+startPage+" End Page :"+endPage,"current Page:"+currentPage)
    pageNumbers.push(
      <li
        key={i}
        className={i === currentPage+1 ? 'page-item active' : 'page-item'}
        onClick={() => onPageChange(i-1)}
      >
      
        <button className="page-link"> {i}</button>
      </li>
    );
  }

  return (
   
    <ul className="pagination">
    <li  className={currentPage === 0 ? 'page-item disabled' : 'page-item'}>
     
      <button onClick={() => onPageChange(0)} className={currentPage === 0 ? 'page-link disabled' : 'page-link'}> {'<<'}</button>
    </li>
    <li  className={currentPage === 0 ? 'page-item disabled' : 'page-item'}>
    <button onClick={() => onPageChange(currentPage - 1)} className={currentPage === 0 ? 'page-link disabled' : 'page-link'}> {'<'}</button>
    </li>
    {pageNumbers}

    <li className={currentPage+1 === totalPages ? 'page-item disabled' : 'page-item'}>
      
      <button  onClick={() => onPageChange(currentPage + 1)}  className={currentPage+1 === totalPages ? 'page-link disabled' : 'page-link'}> {'>'}</button>
    </li>
    <li className={currentPage +1 === totalPages ? 'page-item disabled' : 'page-item'}>

      <button  onClick={() => onPageChange(totalPages-1)} className={currentPage+1 === totalPages ? 'page-link disabled' : 'page-link'}> {'>>'}</button>
    </li>
  </ul>
    
  );
};

export default Pagination2;
